import { gql } from "@apollo/client";

export const UPDATE_USER_LOCATION=gql`
mutation updateUserLocation($data: LocationUpdateInput!) {
  updateUserLocation(data: $data){
    success,
    messages
  }
}
`;

export const GET_LOCATION_LIST = gql`
query getMetrolocations{
  getMetrolocations{
    locations{
      locationName,
      idLocation,
      address,
      city,
      state,
      phoneNumber,
      status,
      timeZone,
      isOnlyUrgentVisit,
      background,
      totalDistance,
      email,
      position{
        lat
        lng
      }
    },
    currentLocationId,
    messages,
    success,
  }
}
`;
